import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { STATUS_COLOR } from './constants';

const StatusPlate = (props) => {
	const { label, remark, color, onClick } = props;

	return (
		<Paper onClick={onClick}>
			<Box
				pr={2}
				py={0.25}
				pl={color ? 3.5 : 2}
				height={56}
				position="relative"
				display="flex"
				flexDirection="column"
				justifyContent="center"
			>
				{color && (
					<Box
						sx={{
							backgroundColor: color,
							position: 'absolute',
							top: 8,
							bottom: 8,
							left: 12,
							width: 4,
							borderRadius: 6,
						}}
					/>
				)}
				{label && <Typography variant="subtitle1">{label}</Typography>}
				{remark && (
					<Typography color="secondary" variant="body2">
						{remark}
					</Typography>
				)}
			</Box>
		</Paper>
	);
};

StatusPlate.propTypes = {
	label: PropTypes.string,
	remark: PropTypes.string,
	color: PropTypes.oneOf(Object.values(STATUS_COLOR)),
	onClick: PropTypes.func,
};

export default StatusPlate;
